<template>
  <div id="tickettabs" class="col-md-12 pl-1 pr-0">
    <div class="spinner-cover-new" v-if="is_loading">
      <div class="spinner"></div>
    </div>
    <photos-modal/>
    <div class="innerdoc pl-1">
      <div class="docuvtabs pt-0">
        <ul class="nav nav-tabs pt-1" id="myTab" role="tablist">
          <li class="nav-item">
            <a class="nav-link active" data-toggle="tab" href="#dtab1" role="tab" aria-controls="dtab1" aria-selected="false">
              <img src="@/assets/images/tab-icon-12.png" alt="icon">
            </a>
          </li>

          <li class="nav-item">
            <a class="nav-link" data-toggle="tab" href="#dtab2" role="tab"
               aria-controls="dtab2" aria-selected="true">
              <img src="@/assets/images/tab-icon-5.png" alt="icon">
            </a>
          </li>

          <li class="nav-item btn-plan-tab">
            <a class="nav-link" data-toggle="tab" href="#dtab3" role="tab" aria-controls="dtab3"
               aria-selected="false"> <img src="@/assets/images/tab-icon-6.png" alt="icon"></a>
          </li>

          <li class="nav-item">
            <a class="nav-link" data-toggle="tab" href="#dtab6" role="tab" aria-controls="dtab6" aria-selected="false"> <img src="@/assets/images/tab-icon-15.png" alt="icon"></a>
          </li>
        </ul>
        <div class="tab-content cscroll screen-height mb-4 scroll-right">
          <div class="text-black tab-pane active" id="dtab1" role="tabpanel">
            <div class="row">
              <div class="col-md-7 f1 text-black">
                <div class="heading mb-2">
                  <h5 class="text-black">
                    <strong>Daten</strong>
                  </h5>
                </div>
                <div class="form-group mt-2 pt-1">
                  <label class="font-weight-bold font1rem mb-1" for="title">Titel</label>
                  <input type="text" class="form-control" v-model="task.flawname" id="title">
                </div>
                <div class="form-group">
                  <label for="des" class="font1rem font-weight-bold">Beschreibung</label>
                  <textarea class="form-control" rows="5" v-model="task.description" id="des"></textarea>
                </div>
                <div class="tblock pt-3" id="task-params-id">
                  <h5 class="font-weight-bold mb-1">Zusatzfelder</h5>
                  <div class="row m-0 pt-1 params-box" v-for="(param, index) in task.flawparams" :key="index">
                    <div class="col-md-5 pl-0 pr-2">
                      <input @change="checkDuplicates" class="input-style form-control font12" :class="{'bg-light': param.isNew !== 'yes'}" v-model="param.paramtitle" :disabled="param.isNew !== 'yes'">
                    </div>
                    <div class="col-md-7 pl-0 pr-2">
                      <input class="input-style form-control font12" v-model="param.paramvalue">
                    </div>
                    <img src="@/assets/images/delete_icon.png" alt="delete" width="17" class="delete-img" title="Remove" @click="removeFlawParam(index)">
                  </div>
                </div>
                <button class="btn btn-light" type="button" @click="addNewFlawParam">
                  <i class="fa fa-plus pr-1"></i> Neues Zusatzfeld
                </button>
              </div>

              <div class="col-md-5 pr-0  border-left text-black border-dark f2 pl-2 pr-2">
                <div class="tblock mb-2">
                  <select class="form-control font13 border-danger col-md-9" v-model="task.status">
                    <option :value="0">Erledigt</option>
                    <option :value="1">Prüfen</option>
                    <option :value="2">Offen</option>
                  </select>
                </div>
                <div class="tblock pt-2">
                  <label class="font-weight-bold font1rem mb-1">Art</label>
                  <select class="form-control font13" v-model="task.flawtype">
                    <option :value="1">Mangel</option>
                    <option :value="2">Restleistung</option>
                  </select>
                </div>

                <div class="tblock scroll-services card shadow border pl-2 pt-2 pb-2">
                  <h5 class="font-weight-bold mb-1">Gewerk </h5>
                  <ul class="list-group-flush">
                    <li v-for="(service , index) in services" :key="index" class="list-group-item pt-2 pb-1 pl-0 pr-0">
                      <div class="btns">
                        <input type="checkbox" class="w-auto service-checkbox" :value="{ pdserviceid: `${service.pdserviceid}-${service.projectuserserviceid}` , title: ''}" :id="'serv'+index" v-model="selectedTrades">
                        <label class="d-inline" :for="'serv'+index">
                          {{service.pdservicetitle}}
                          <span v-if="service.company">
                            ( {{ service.company }} )
                          </span>
                        </label>
                      </div>
                    </li>
                  </ul>
                </div>

                <div class="tblock user pt-3">
                  <h5 class="mb-2 font-weight-bold">Verantwortlicher</h5>
                  <div class="row mt-2 mb-2 mr-0">
                    <div class="col-sm-3  text-black pr-0 text-center">
                      <img src="@/assets/images/user.png" class="img-fluid w-75 rounded-circle" alt="userIng">
                    </div>
                    <div class="col-sm-9 pr-0 pl-1">
                      <select class="form-control font13 pl-2" v-model="task.responsibleuser">
                        <option v-for="user in projectUsers" :value="user.pduserid">
                          {{user.firstname}} {{user.lastname}}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="tblock text-black">
                  <h5 class="font-weight-bold">Festgestellt am</h5>
                  <input class="datepicker form-control font13 mt-2" :value="setDate(task.noticedate)" data-date-format="dd.mm.yyyy" id="notice">
                </div>
                <div class="tblock text-black mb-2">
                  <h5 class="font-weight-bold">Angezeigt am</h5>
                  <input class="datepicker form-control font13 mt-2" :value="setDate(task.notifiedate)" data-date-format="dd.mm.yyyy" id="notifi">
                </div>
                <div class="tblock text-black mb-2">
                  <h5 class="font-weight-bold">Frist</h5>
                  <input class="datepicker form-control font13 mt-2" :value="setDate(task.fristdate)" data-date-format="dd.mm.yyyy" id="frist">
                </div>
                <div class="tblock text-black">
                  <h5 class="font-weight-bold">Erledigt am</h5>
                  <input class="datepicker done-date form-control font13 mt-2" :value="setDate(task.donedate)" data-date-format="dd.mm.yyyy" id="done">
                </div>

                <div class="tblock  text-black user">
                  <h5 class="font-weight-bold">Ersteller</h5>
                  <div class="row mt-2 mb-2 mr-0">
                    <div class="col-sm-3  text-black pr-0 text-center">
                      <img src="@/assets/images/user.png" class="img-fluid w-75 rounded-circle" alt="userIng">
                    </div>
                    <div class="col-sm-9 pr-0 pl-1">
                      <p class="m-0 pt-1 font13">{{task.creator}} </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="tab-pane" id="dtab2" role="tabpanel">
            <div class="pb-5">
              <h4>Fotos </h4>
              <div class="picswrap pb-3">
                <div class="cpics border-top">
                  <div class="form-row ml-0 mr-0 mt-2">
                    <div class="col col-md-4 pl-0" v-for="(photo ,i) in photos" :key="i">
                      <div class="simple-photo m-0">
                        <div @click="removePhoto(i)" class="position-absolute remove-img">
                          <img src="@/assets/images/delete_icon.png" data-value="btn" alt="remove" class="img-fluid"   title="Löschen" style="width: 20px">
                        </div>
                        <Popup :photo="photo" :taskModule="true" />
                        <div  data-aspect-ratio="4:3" class="img-fluid">
                          <div :style="{'background-image': 'url(\'' + photo.src + '\')'}"></div>
                        </div>
                        <div class="simple-photo-option">
                          <ul>
                            <li>Nr.{{photo.runid}}</li>
                            <li>|</li>
                            <li>{{photo.photodate | date}}  </li>
                            <li>|</li>
                            <li> {{ photo.photodate.substr(11,5) }} Uhr</li>
                          </ul>
                        </div>
                      </div>
                      <div class="card p-1 font13">
                        <p>
                          <strong class="font13">Beschreibung :</strong>
                        </p>
                        <textarea v-model="photo.description" rows="4" class="p-1 form-control form-control-sm"></textarea>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <button class="btn btn-light font1rem p-2 rounded"  data-toggle="modal" data-target="#tasks-photos_Modal">
                Fotos hinzufügen
              </button>
            </div>
          </div>

<!--            Plan tab-->

         <edit-task-canvas/>

<!--            History Tab-->
          <div class="tab-pane" id="dtab6" role="tabpanel">
            <history-tab/>
          </div>

          <div class="doku-btns-sticky pt-1">
            <span class="btninner">
              <button type="button" class="btn btn-danger" @click="isEdit = false; detailsPage = true">
                Abbrechen
              </button>
              <button type="button" class="btn btn-primary" @click="updateTask">
                Speichern
              </button>
            </span>
          </div>
        </div>
      </div>
      <div class="clearfix"></div>
    </div>
  </div>
</template>
<script>
import {mapState} from 'vuex'
import {formatAsInputDate, formatDate} from '../common'
import Popup from '../photo/components/infoPopup'
import HistoryTab from './preview-tabs/HistoryTab'
import PhotosModal from './PhotosModal'
import EditTaskCanvas from './EditTaskCanvas'
export default {
  props: ['taskPhotosParams'],
  components: {PhotosModal, HistoryTab, Popup , EditTaskCanvas},
  data() {
    return {
      isFirst: true,
      duplicates: false
    }
  },
  mounted () {
   this.setDatePicker();
  },
  computed: {
    ...mapState({
      is_loading: state => state.constructionDiary.is_loading,
      services: state => state.tasks.servicesWithCompanies,
      task: state => state.tasks.editTaskDetails,
      projectUsers: state => state.appSettings.projectUsers,
      task_photos: state => state.tasks.taskEditPhotos,
      plan: state => state.tasks.taskPlanImage,
      default_params: state => state.tasks.default_params,
      authUser: state => state.projects.user
    }),
    photos(){
      this.task_photos.forEach(photo => {
       let task_photo =  this.task.flawitems.find(item => item.pdphotoid == photo.pdphotoid);
       if (task_photo)
         photo.description = task_photo.pdphototext
      })
      return this.task_photos
    },


    selectedTrades: {
      get(){
        return this.task.selectedtrades
      },
      set(val){
        this.$store.commit('setEditTaskDetailsServices',val)
      }
    },

    detailsPage: {
      get(){
        return this.$store.state.tasks.detailsPage
      },set(val){
        this.$store.commit('toggleTasksDetails',val)
      }
    },
    isEdit: {
      get(){
        return this.$store.state.tasks.isEdit
      },set(val){
        this.$store.commit('setTasksIsEdit',val)
      }
    },
  },
  filters: {
    date: (d) => formatDate(d)
  },
  methods: {

    checkDuplicates(event){
      const value = event.target.value.toLowerCase()
      this.duplicates = this.task.flawparams.filter(item => item.paramtitle.toLowerCase() === value).length === 2;
      if (this.duplicates){
        event.target.classList.add('is-invalid')
      }else {
        event.target.classList.remove('is-invalid')
      }
    },

    addNewFlawParam () {
      const param = {
        "pduserid": this.authUser.pduserid,
        "pdflawid": this.task.pdflawid,
        "status": 0,
        "created": new Date(),
        "paramtitle": "",
        "paramvalue": "",
        "pdflawitemid": 0,
        "projectid": this.$route.params.id,
        "creator": 0,
        "isNew": 'yes',
        "_explicitType": "com\\projectdocu\\PDFlawParamsVO"
      }
      this.task.flawparams.push(param)
    },

    removeFlawParam(index){
      this.task.flawparams.splice(index, 1);
    },

    setDatePicker () {
      this.$store.commit('loading', true);
      let _this = this
      $('.datepicker').datepicker({
        autoclose: true,
        todayHighlight: true,
      }).on('changeDate', function(ev){
        let attr = ev.target.getAttribute('id');
        if (attr === 'frist'){
          _this.task.fristdate = formatAsInputDate(ev.target.value);
        }else if (attr === 'done') {
          _this.task.donedate = formatAsInputDate(ev.target.value);
        } else if (attr === 'notifi') {
          _this.task.notifiedate = formatAsInputDate(ev.target.value);
        } else if (attr === 'notice') {
          _this.task.noticedate = formatAsInputDate(ev.target.value);
        }
      });
      this.$store.commit('loading', false);
    },

    async updateTask () {
      this.$store.commit('loading',true);
      if (this.duplicates){
        this.duplicates = !!document.querySelector("#task-params-id .is-invalid")
      }
      if (!this.duplicates){
        const task = {...this.task};
        task.flawitems = [];
        this.photos.forEach(photo => {
          let flawItem = {
            _explicitType: "com\\\\projectdocu\\\\PDFlawItemVO",
            pdflawid: task.pdflawid,
            pdphotoid: photo.pdphotoid,
            pdflawitemid: 0,
            pdphototext: photo.description
          }
          task.flawitems.push(flawItem);
        });
        task.pdprojectid = this.$route.params.id
        task.pdflawflags.forEach(flag => {
          delete flag.src
        });
        task.flawurl = `/backend/get?method=flaw&fid=${task.pdflawid}`
        task.selectedtrades.forEach(item => {
          item.pdserviceid = item.pdserviceid.replace('null','0');
        });
        await this.$store.dispatch('updateTaskDetails',task);
        this.$emit('getTasks')
        this.isEdit = false;
        this.detailsPage = true;
        const new_task = await this.$store.dispatch('getTaskDetailsById', [task.pdflawid]);
        await this.$store.dispatch('getImagesByIdsTasksModule', this.taskPhotosParams(task.flawitems));
        // set default params
        const params = new_task.flawparams.map(prm => prm.paramtitle.toLowerCase())
        const d_params = JSON.parse(JSON.stringify(this.default_params))
        d_params.forEach(itm => {
          if (!params.includes(itm.paramtitle.toLowerCase())){
            new_task.flawparams.push(itm)
          }
        });
      }else {
        this.$toast.error("Bitte lösen Sie doppelte zusätzliche Felder auf")
      }
      this.$store.commit('loading',false);
    },

    user (id) {
      return this.projectUsers.find(item => id === item.pduserid)
    },

    setDate(date){
      return formatDate(date)
    },

    getUser(id){
      this.projectUsers.find(user => user.pduserid === id)
    },

    getService (service_id) {
      let id = service_id.split('-');
      return this.services.find(item => item.pdserviceid === parseInt(id[0]))
    },

    removePhoto(index) {
      this.$store.commit('removeTaskEditPhotos',index);
    },
    autoGrow(element) {
      element.style.height = "5px";
      element.style.height = (element.scrollHeight)+"px";
    },
  }
}
</script>
<style scoped>
.docuvtabs .tab-content{
  max-width: 90% !important;
}
.scroll-right.screen-height {
  height: calc(100vh - 162px) !important;
}
input.service-checkbox{
  vertical-align: middle;
  margin-top: -3px;
  margin-right: 3px;
}
.doku-btns-sticky{
  bottom: 1px;
  z-index: 100;
  position: absolute;
  width: 81%;
  text-align: center;
  background: #ffffff7a;
  border-top: 1px solid grey;
}
.doku-btns-sticky button{
  font-size: 14px;
  font-weight: normal !important;
  padding: 6px 18px;
  line-height: 1.3;
}
.scroll-services{
  max-height: 15.5rem;
  overflow-x: hidden;
  overflow-y:auto ;
}
.scroll-services::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .6);
  background-color: #3399ff9e;
  opacity: 1;
}
.scroll-services::-webkit-scrollbar {
  width: 6px;
  background-color: #ffffff;
}
img.delete-img{
  position: absolute;
  right: 4px;
  margin-top: 2px;
  display: none;
  cursor: pointer;
}
.params-box:hover .delete-img{
  display: block;
}
.simple-photo .remove-img{
  width: 19px;
  z-index: 99;
  cursor: pointer;
  visibility: hidden;
  top: 4px;
  left: 4px;
}
.simple-photo:hover .remove-img{
  visibility: visible;
}
</style>



// WEBPACK FOOTER //
// src/components/tasks/EditTask.vue